module.exports = __webpack_public_path__ + "static/media/image003.9b99ad46.webp";